import { Reveal } from "../components/Reveal";
import ContactForm from "../components/ContactForm";
import SocialLinks from "../components/SocialLinks";
import { SITE } from "../config/site";

export default function FinalCTA() {
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="relative scroll-mt-20 overflow-hidden bg-paper text-ink"
    >
      <span
        className="pointer-events-none absolute -bottom-24 left-0 select-none font-display text-[16rem] font-extrabold uppercase leading-none text-ink/[0.04] sm:text-[22rem]"
        aria-hidden="true"
      >
        OOO
      </span>
      <div className="relative mx-auto max-w-7xl px-4 py-28 sm:px-6 lg:px-8 lg:py-40">
        <Reveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-ink/60 sm:text-xs">
            Ready when you are
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <h2 className="mt-8 font-display text-4xl font-bold uppercase leading-[1.1] tracking-tight sm:text-6xl sm:leading-[1.06] lg:text-7xl">
            Let's make something
            <br />
            <span className="text-uv">people can't ignore.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-12">
          <Reveal delay={0.2} className="lg:col-span-5">
            <p className="max-w-sm text-base leading-relaxed text-ink/70">
              Tell us about the show, the space or the object. It lands in a real inbox and we
              reply fast.
            </p>
            <div className="mt-10 space-y-5">
              <a
                href={`mailto:${SITE.email}`}
                data-testid="final-cta-email"
                className="block font-display text-2xl font-bold text-ink transition-colors duration-300 hover:text-uv"
              >
                {SITE.email}
              </a>
              <a
                href={SITE.phoneHref}
                data-testid="final-cta-phone"
                className="block font-mono text-sm tracking-[0.15em] text-ink/70 transition-colors duration-300 hover:text-ink"
              >
                {SITE.phone}
              </a>
              <div className="border-t border-ink/15 pt-5">
                <p className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.3em] text-ink/50">
                  {SITE.address1}
                  <br />
                  {SITE.address2}
                </p>
                <p className="mt-3 font-mono text-[10px] uppercase leading-relaxed tracking-[0.25em] text-ink/50">
                  {SITE.travel}
                </p>
              </div>
              <SocialLinks light />
            </div>
          </Reveal>
          <Reveal delay={0.3} className="lg:col-span-7">
            <ContactForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
